import { render, staticRenderFns } from "./BalanceCard.vue?vue&type=template&id=0454447c&scoped=true"
import script from "./BalanceCard.vue?vue&type=script&lang=js"
export * from "./BalanceCard.vue?vue&type=script&lang=js"
import style0 from "./BalanceCard.vue?vue&type=style&index=0&id=0454447c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0454447c",
  null
  
)

export default component.exports